<template>
  <v-dialog persistent v-model="openReportGreetingModel" max-width="400">
    <v-card>
      <v-card-title class="gc-text-h6">{{ lang.profile.w4 }}</v-card-title>
      <v-card-text v-if="currentGreeting && currentGreeting.user"
        >{{ lang.profile.w5 }}
        <span class="font-weight-bold">{{
          currentGreeting.user.name + " " + currentGreeting.user.surname
        }}</span
        >?</v-card-text
      >
      <v-card-text>
        <div class="input-group" style="width: 100%">
          <label>{{ lang.reports.ReportReason }} *</label>
          <select v-model="reportReason" class="custom-select">
            <option
              v-for="(report, ind) in reportLastGreetingsItems"
              :key="ind"
              :value="report.value"
            >
              {{ report.text }}
            </option>
          </select>
        </div>
        <div class="input-group mt-3" v-if="reportReason == 'Other'">
          <label>{{ lang.reports.OtherReason }} *</label>
          <textarea v-model="reportOther" rows="4"></textarea>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          elevation="0"
          small
          class="primary--text"
          @click="closeLastGreetingReport()"
        >
          {{ lang.actions.cancel }}
        </v-btn>
        <v-btn
          small
          class="ml-2 btn-bg"
          elevation="0"
          @click="reportLastGreeting()"
        >
          {{ lang.actions.report }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ReportGreetingDialog",
  props: {
    currentGreeting: {
      type: Object,
    },
    openReportGreetingModel: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      reportReason: "",
      reportOther: "",
    };
  },
  computed: {
    ...mapGetters(["rules"]),
    lang() {
      return this.$store.state.langObj || {};
    },
    reportLastGreetingsItems() {
      return [
        {
          value: "Inappropriate content",
          text: this.lang.reports.Reasons.inappropriateContent,
        },
        {
          value: "Spam or promotional content",
          text: this.lang.reports.Reasons.spam,
        },
        {
          value: "Personal attacks",
          text: this.lang.reports.Reasons.personalAttacks,
        },
        {
          value: "Other",
          text: this.lang.reports.Reasons.other,
        },
      ];
    },
  },
  methods: {
    closeLastGreetingReport() {
      this.$emit("closeLastGreetingReport");
    },
    reportLastGreeting() {
      if (
        (this.reportReason &&
          this.reportReason == "Other" &&
          this.reportOther) ||
        (this.reportReason && this.reportReason != "Other")
      ) {
        this.$emit("reportLastGreeting", this.reportReason, this.reportOther);
      } else {
        this.$store.commit("toast", {
          message: this.lang.general.fillAllFields,
          color: "red lighten-2",
        });
      }
    },
  },
};
</script>
